import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useIsAdmin } from '@/hooks/useAdmin';
import { LoadingSpinner } from '@/components/LoadingSpinner';

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuthStore();
  const { data: isAdmin, isLoading: adminLoading } = useIsAdmin();

  if (authLoading || adminLoading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
